module.exports = "/_next/static/images/AIAndML-xs-9c98d79a193ba42d6c8890aa562e32f6.webp";